import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { UserServiceClass } from 'app/layout/common/user/user.service'
import { environment } from 'environments/environment';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    // exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    userData: any;
    rolesLst = [];
    roleMap: any[] = [];
    usrId = sessionStorage.getItem('usrId');
    activeRole = sessionStorage.getItem('activeRole');
    environment = environment;

    //onboarding tour variable

    showOnboarding = false;
    currentPopupIndex: number = 7;
    isFirstClick!: boolean;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private service: UserServiceClass
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.userData = sessionStorage.getItem('usr');      //To get User Data from sessionStorage
        this.userData = JSON.parse(this.userData);
        this.getRoles();
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
                // console.log(this.user);

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    log(msg) {
        console.log(msg);
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    switchRole(role) {
        //function body        
        sessionStorage.setItem('activeRole', role);
        this._router.navigate(['/'])
            .then(() => {
                window.location.reload();
            });
    }

    getRctrRtgQnaLnk() {
        let rctrId = sessionStorage.getItem("rctrId");
        return ['/recruiter/rctrRtgQna/dtl-vw/' + rctrId];
    }
    isRctr() {
        let activeRole = sessionStorage.getItem("activeRole");
        if (activeRole == "rctr_usr") {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Sign out
     */
    signOut(): void {
        var token = sessionStorage.getItem('accessToken');
        let data = {
            accessToken: token
        }
        this.service.signOut(data).subscribe((response) => {
            console.log(response);
        }), (error) => {
            console.log(`Getting Error ${error}`);
        }
        let pltfrm = sessionStorage.getItem('pltf');
        sessionStorage.clear();
        sessionStorage.setItem('pltf', pltfrm);
        this._router.navigate(['/sign-out']);
    }

    openProfile() {
        let role = sessionStorage.getItem('activeRole');
        if (role === 'rctr_admin' || role === 'rctr_usr') {
            let rctrId = sessionStorage.getItem('rctrId');
            this._router.navigateByUrl(`/marketplace/rctr/dtl-vw/${rctrId}`);
        } else if(role === 'cndt_usr') {
            let cndtId = sessionStorage.getItem('cndtId');
            this._router.navigateByUrl(`/recruiter/cndt/cndt/dtl-vw/${cndtId}`);
        } else {
            let userID = sessionStorage.getItem('usrId');
            this._router.navigateByUrl(`/profile/usr/dtl-vw/${userID}`);
        }
    }

    getRoles() {
        let roles = JSON.parse(sessionStorage.userRoles);
        this.rolesLst = roles.split(',');
        // console.log(this.rolesLst.length);
    }

    getUrl(usrId) {
        return `${environment.s3FileBktUrl}/usr/${usrId}/profile/${usrId}`;
    }

    // ==> Onboarding tour code

    startTour(): void {
        if (this.currentPopupIndex === 7) {
            this.currentPopupIndex = 7;
            this.showOnboarding = true;
            console.log('Starting onboarding tour from the 5th position...');
        } else {
            console.log('No onboarding tour to start.');
        }
    }

    finishOnboarding(): void {
        this.showOnboarding = false;
        console.log('Onboarding tour finished');
    }

    skipOnboarding(): void {
        this.showOnboarding = false;
        console.log('Onboarding tour skipped');
    }
}
